import styled from 'styled-components';

const HeroContainer = styled.div<{ isBlue: boolean }>`
  filter: sepia(10%);
  filter: brightness(95%);
  /* stylelint-disable */
  background: linear-gradient(
    135deg,
    ${(props) =>
    props.isBlue ? 'rgb(31, 135, 229) 50%' : 'rgb(240, 97, 103) 50%'},
    rgb(255, 255, 255) 150%
  );
  /* stylelint-enable */
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const HeroWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 300px;
  width: 500px;
  position: relative;
  z-index: 1;
`;

const ContentContainer = styled.div`
  z-index: 3;
  max-width: 1200;
  position: absolute;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeroTitle = styled.h1`
  color: #fff;
  font-weight: bold;
`;

export {HeroContainer, HeroWrapper, ContentContainer, HeroTitle};
